<template>
  <div class="relative container flex flex-col flex-wrap mx-auto px-4 z-0 bg-transparent z-0 pb-8 lg:pb-20 pt-14 md:pt-16 items-center justify-center min-h-[90vh]">
    <h1 class="text-4xl font-semibold tracking-widest text-turquoise-300 mb-4">HALL OF FAME</h1>
    <table class="table w-fit text-white/80 font-medium tracking-wide rounded-2xl border-white/20 bg-white/10">
      <tbody>
        <tr v-for="(project, index) in projects" class="border-woodsmoke-600">
          <th class="p-2 sm:p-3 border-woodsmoke-600">
            <img class="w-7 sm:w-10 object-contain rounded-md p-0 sm:p-1" :src="project.src" :alt="`${project.title} logo in Oxbull hall of fame`" />
          </th>
          <th class="border-woodsmoke-600">#{{ index + 1 }}</th>
          <td class="border-woodsmoke-600">{{ project.title }}</td>
          <td class="text-turquoise-300 font-medium tracking-wide border-woodsmoke-600">ROI: {{ project.roi }}</td>
        </tr>
      </tbody>
    </table>
    <div class="absolute z-0 w-[80vw] h-[80vw] rounded-full bg-gradient-to-b from-turquoise-500 to-turquoise-1000 blur-3xl opacity-20 -top-[20vh]"></div>
  </div>
</template>

<script setup>
const projects = [
  {
    title: "Catecoin",
    src: "/images/catecoin-logo.png",
    roi: "3606.1x",
  },
  {
    title: "Altura",
    src: "/images/altura-logo.png",
    roi: "811.2x",
  },
  {
    title: "Bloktopia",
    src: "/images/bloktopia-logo.png",
    roi: "773.2x",
  },
  {
    title: "Sidus Heroes",
    src: "/images/sidus-logo.png",
    roi: "161.1x",
  },
  {
    title: "Farcana",
    src: "/images/farcana-logo.webp",
    roi: "27.0x",
  },
  {
    title: "Catpay",
    src: "/images/catpay-logo.png",
    roi: "13.6x",
  },
  {
    title: "Affyn",
    src: "/images/affyn-logo.png",
    roi: "12.1x",
  },
];
</script>
